import { UDField } from '../../../users/UDField';
import { DM_LOCALES } from './dmForms.ts';

interface DmLocaleSelectProps {
    value: string;
    onChange: (locale: string) => void;
}

export function DmLocaleSelect({ value, onChange }: DmLocaleSelectProps) {
    return (
        <UDField label="DM language">
            <select
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="h-10 rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-800 outline-none focus:border-gray-800 focus:ring-2 focus:ring-gray-200"
            >
                {DM_LOCALES.map((locale) => (
                    <option key={locale} value={locale}>
                        {locale}
                    </option>
                ))}
            </select>
        </UDField>
    );
}
